export default __webpack_public_path__ + "8918c6411881646fdcfc50bc9e091a5d.otf";